import React from 'react';
import { Phone, MessageSquare, Mail } from 'lucide-react';
import { projectInfo } from '../data/mock';

const StickyFooter = ({ onEnquireClick }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-[#0a1628]/95 backdrop-blur-md border-t border-white/10 py-3 px-4 lg:hidden">
      <div className="flex items-center justify-around gap-2">
        {/* Enquire */}
        <button
          onClick={onEnquireClick}
          className="flex-1 flex items-center justify-center gap-2 bg-gradient-to-r from-[#c9a961] to-[#a08545] text-[#0a1628] font-semibold py-3 rounded-full"
        >
          <Mail className="w-5 h-5" />
          <span>Enquire</span>
        </button>

        {/* WhatsApp */}
        <a
          href={`https://api.whatsapp.com/send?phone=919066840485&text=${encodeURIComponent(projectInfo.whatsappMessage)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 flex items-center justify-center gap-2 bg-green-600 text-white font-semibold py-3 rounded-full"
        >
          <MessageSquare className="w-5 h-5" />
          <span>WhatsApp</span>
        </a>

        {/* Call */}
        <a
          href={`tel:${projectInfo.phone}`}
          className="flex-1 flex items-center justify-center gap-2 bg-white/10 border border-white/20 text-white font-semibold py-3 rounded-full"
        >
          <Phone className="w-5 h-5" />
          <span>Call</span>
        </a>
      </div>
    </div>
  );
};

export default StickyFooter;
